var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKakoa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 100,
    height: 100,
    rx: 30,
    fill: "#808080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1955 25.7195C24.2785 25.5095 5.77012 67.652 42.0716 86.3732C41.4333 88.5726 37.9726 100.525 37.8341 101.464C37.7354 102.199 38.295 102.814 39.2022 102.499C40.5133 102.316 54.3958 92.5638 56.7988 90.8706C114.361 97.7602 125.696 28.3635 64.1955 25.7195Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.574 67.7206C43.4962 70.7385 38.8512 70.7502 38.7688 67.7206V53.4479H35.0202C31.9154 53.3691 31.909 48.8237 35.0202 48.7432H47.3226C50.4292 48.8256 50.4328 53.3655 47.3226 53.4479H43.574V67.7206Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7655 69.6519C62.6872 70.2205 60.601 70.082 60.2388 68.9221L59.049 65.8073H51.723L50.5323 68.9239C50.172 70.082 48.0849 70.2214 47.0074 69.6519C46.3446 69.3468 45.7081 68.5065 46.4379 66.2401L52.1848 51.1145C53.361 48.0124 57.4056 47.9989 58.5891 51.1172L64.3333 66.2365C65.064 68.5074 64.4274 69.3477 63.7655 69.6519Z",
    fill: "#808080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9077 69.6649H68.1995C66.9301 69.6649 65.897 68.677 65.897 67.4628V51.1456C65.9794 47.9838 70.7176 47.9738 70.8018 51.1456V65.2599H75.9077C78.94 65.335 78.9464 69.5879 75.9077 69.6649Z",
    fill: "#808080"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7147 67.8565C94.501 69.9164 91.6063 70.6752 90.4183 68.9711L84.7846 61.5056L83.9507 62.3395V67.5812C83.8719 70.7431 79.2278 70.7548 79.1445 67.5821V51.1463C79.2278 47.9817 83.8647 47.9754 83.9498 51.1463V56.3101L90.6529 49.607C91.4569 48.7912 92.8549 48.9669 93.639 49.7818C94.4549 50.5569 94.6314 51.9712 93.8156 52.768L88.3403 58.2424L94.2539 66.0773C94.6387 66.5843 94.8044 67.2254 94.7147 67.8565Z",
    fill: "#808080"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9868 61.5525H57.7857L55.3863 54.7354L52.9868 61.5525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakoa);
export default __webpack_public_path__ + "static/media/Kakoa.b75506912e2b02686d77199ceeb58a3f.svg";
export { ForwardRef as ReactComponent };